import React from "react";
import { Route, Routes } from "react-router-dom";
import { CategoryList, CategoryDetails, CreateAndEditCategory } from "..";
import { ProtectedRoute } from "../../shared";
import { ManageCategorySeo } from "./containers/ManageCategorySeo";

export const Category = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<CategoryList />} />
        <Route element={<ProtectedRoute allowedRoute={["category-modify"]} />}>
          <Route path="/details/edit/:id" element={<CreateAndEditCategory />} />
          <Route
            path="/details/:categoryId/seo/edit"
            element={<ManageCategorySeo />}
          />
        </Route>
        <Route
          element={<ProtectedRoute allowedRoute={["category-view"]} />}
        >
          <Route path="/details/:id" element={<CategoryDetails />} />
        </Route>

        {/* <Route
          element={<ProtectedRoute allowedRoute={["category-modify"]} />}
        >
          <Route path="/details/:id/products" element={<CategoryProductList />} />
        </Route> */}
        <Route element={<ProtectedRoute allowedRoute={["category-create"]} />}>
          <Route path="/create" element={<CreateAndEditCategory />} />
        </Route>
      </Routes>
    </>
  );
};
